/* corex-textil-editor-overlay.js · Controles HTML sobre la prenda del personalizador de camisetas: barra flotante de
   alineación (estilo Illustrator: barra + bloques) encima del elemento seleccionado y etiqueta editable de la cota
   ("8 cm ✎"). Solo posiciona y genera HTML; las acciones las hace corex-textil-editor.js. */
(function () {
  'use strict';

  var IO = window.CorexTextilIO;
  var esc = IO.esc;
  var GAP_PX = 14;
  var EDGE_PX = 4;

  function svg(rects) {
    return '<svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true" fill="currentColor">' +
      rects.map(function (r) { return '<rect x="' + r[0] + '" y="' + r[1] + '" width="' + r[2] + '" height="' + r[3] + '"/>'; }).join('') + '</svg>';
  }
  var ICON = {
    left: svg([[1.5, 1, 1.6, 18], [4.5, 4, 12, 4], [4.5, 11, 7.5, 4]]),
    centerH: svg([[9.2, 1, 1.6, 18], [4, 4, 12, 4], [6.2, 11, 7.6, 4]]),
    right: svg([[16.9, 1, 1.6, 18], [3.5, 4, 12, 4], [8, 11, 7.5, 4]]),
    top: svg([[1, 1.5, 18, 1.6], [4, 4.5, 4, 12], [11, 4.5, 4, 7.5]]),
    centerV: svg([[1, 9.2, 18, 1.6], [4, 4, 4, 12], [11, 6.2, 4, 7.6]]),
    bottom: svg([[1, 16.9, 18, 1.6], [4, 3.5, 4, 12], [11, 8, 4, 7.5]])
  };
  /* Izquierda/derecha = de la imagen: el borde del diseño hace tope con el límite útil de ese costado. Logo de pecho
     derecho de quien la lleva = izquierda de la imagen (y al revés); esos van en «Más opciones». */
  function opDefs(zone) {
    var ref = zone.ref === 'cintura' ? 'de la cintura' : 'del cuello';
    var hem = zone.ref === 'bajo_pierna' ? 'del bajo de la pierna' : 'del bajo de la manga';
    return {
      'borde-izq': { label: 'Alinear a la izquierda (tope con el costado)', icon: ICON.left },
      'centro-h': { label: 'Centrar en horizontal', icon: ICON.centerH },
      'borde-der': { label: 'Alinear a la derecha (tope con el costado)', icon: ICON.right },
      arriba: { label: 'Arriba (a ' + zone.defaultDist + ' cm ' + ref + ')', icon: ICON.top },
      'centro-v': { label: 'Centrar en vertical', icon: ICON.centerV },
      'manga-centro': { label: 'Centrar', icon: ICON.centerH },
      'manga-abajo': { label: 'Abajo (a ' + zone.defaultDist + ' cm ' + hem + ')', icon: ICON.bottom },
      borrar: { label: 'Borrar', icon: IO.ICON_TRASH, danger: true }
    };
  }
  /* Delante y detrás: izquierda, centrar, derecha, arriba, centrar vertical y borrar; mangas, solo centrar y abajo. */
  function opsFor(zone) {
    if (zone.kind === 'sleeve') return ['manga-centro', 'manga-abajo', 'borrar'];
    return ['borde-izq', 'centro-h', 'borde-der', 'arriba', 'centro-v', 'borrar'];
  }
  function toolbar(zone) {
    var defs = opDefs(zone);
    return opsFor(zone).map(function (op) {
      var d = defs[op];
      return '<button type="button" class="cte-fl__b' + (d.danger ? ' is-danger' : '') + '" data-cte-op="' + op + '" title="' + esc(d.label) +
        '" aria-label="' + esc(d.label) + '">' + d.icon + '</button>';
    }).join('');
  }

  /* Punto de la imagen de la prenda (px de imagen) → px CSS dentro del escenario. m: metrics del editor. */
  function toCss(m, canvas, x, y) {
    return { x: canvas.offsetLeft + (x - m.frame.view.x) * m.s, y: canvas.offsetTop + (y - m.frame.view.y) * m.s };
  }
  function overlap1(a, b) { return !!b && a.x0 < b.x1 && b.x0 < a.x1 && a.y0 < b.y1 && b.y0 < a.y1; }
  /* b: una caja o una lista de cajas (null se ignora) */
  function overlaps(a, b) { return Array.isArray(b) ? b.some(function (x) { return overlap1(a, x); }) : overlap1(a, b); }
  /* Barra junto al elemento (caja CSS) sin tapar las etiquetas (avoid: caja o lista): prueba encima, debajo y debajo
     de las etiquetas, centrada o a un lado de lo que tape; si nada cabe, encima. Siempre dentro del escenario. */
  function placeFloat(el, stage, box, avoid) {
    var w = el.offsetWidth, h = el.offsetHeight, sw = stage.clientWidth, sh = stage.clientHeight;
    var rects = [].concat(avoid || []).filter(Boolean);
    var clampX = function (x) { return Math.min(Math.max(x, EDGE_PX), Math.max(EDGE_PX, sw - w - EDGE_PX)); };
    var rect = function (x, y) { return { x0: x, x1: x + w, y0: y, y1: y + h }; };
    var center = clampX((box.x0 + box.x1) / 2 - w / 2), above = box.y0 - h - GAP_PX;
    var lowest = rects.reduce(function (m, r) { return Math.max(m, r.y1); }, box.y1);
    var tops = [above, box.y1 + GAP_PX, lowest + 6].filter(function (y) { return y >= EDGE_PX && y + h <= sh - EDGE_PX; });
    var lefts = [center].concat(rects.map(function (r) { return clampX(r.x1 + 6); }), rects.map(function (r) { return clampX(r.x0 - w - 6); }));
    var pick = null;
    tops.some(function (y) { return lefts.some(function (x) { if (!overlaps(rect(x, y), rects)) pick = { x: x, y: y }; return !!pick; }); });
    if (!pick) pick = { x: center, y: Math.max(EDGE_PX, above) };
    el.style.left = Math.round(pick.x) + 'px';
    el.style.top = Math.round(pick.y) + 'px';
  }
  /* Etiqueta de la cota: su borde derecho en el punto de la cota, centrada en vertical (sin salirse por la izquierda). */
  function placeCota(el, pt) {
    var w = el.offsetWidth, h = el.offsetHeight, x = Math.round(Math.max(EDGE_PX, pt.x - w)), y = Math.round(pt.y - h / 2);
    el.style.left = x + 'px';
    el.style.top = y + 'px';
    return { x0: x - 4, x1: x + w + 4, y0: y - 4, y1: y + h + 4 };
  }

  window.CorexTextilOverlay = { opsFor: opsFor, toolbar: toolbar, toCss: toCss, placeFloat: placeFloat, placeCota: placeCota };
})();
